module.exports = __webpack_public_path__ + "static/media/back_button.900e3222.png";